var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15625 0.71875V5.09375H11.5312C11.8867 5.09375 12.1875 5.39453 12.1875 5.75C12.1875 6.13281 11.8867 6.40625 11.5312 6.40625H7.15625V10.7812C7.15625 11.1641 6.85547 11.4375 6.5 11.4375C6.11719 11.4375 5.84375 11.1641 5.84375 10.7812V6.40625H1.46875C1.08594 6.40625 0.8125 6.13281 0.8125 5.75C0.8125 5.39453 1.08594 5.09375 1.46875 5.09375H5.84375V0.71875C5.84375 0.363281 6.11719 0.0625 6.5 0.0625C6.85547 0.0625 7.15625 0.363281 7.15625 0.71875Z",
    fill: "#223651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ba6c872b3e8a12523839195a2fa32702.svg";
export { ForwardRef as ReactComponent };